module.exports = __webpack_public_path__ + "assets/img/check-2.0385fabe.svg";